import styled from 'styled-components';

export const IncidentsGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export const IncidentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 20px;

  &:last-child {
    border: none;
  }

  h4 {
    margin: 0 0 10px 0;
    color: ${({ theme }) => theme.brand.primary};
    font-weight: 600;
  }
`;

export const IncidentDetails = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 20px;
  background-color: #ffffff;
  text-align: left;
  padding: 15px 5px;

  .incident-details {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .incident-title {
    font-weight: 600;
    font-size: 16px;
    margin: 0;
  }

  .incident-timings {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 0px;

    .incident-timings-time {
      display: flex;
      align-items: center;
      gap: 5px;
      background-color: #ebecf4;
      padding: 4px;
      border-radius: 6px;

      p {
        margin: 0;
        background-color: #ffffff;
        color: #212121;
        padding: 5px 10px;
        border-radius: 6px;
        font-size: 12px;
      }
    }
  }

  .incident-cause {
    border-radius: 6px;
    border: 1px solid #eaeaea;
  }

  .incident-root-cause {
    margin: 0;
    display: flex;
    align-items: center
    gap: 5px;
    padding: 5px 10px;
  }

  .incident-description {
    margin: 0;
    font-size: 12px;
    color: #212121;
    background-color: #ebecf4;
    padding: 5px 10px;
    border-radius: 4px;
  }

  .incident-apps {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 0px;

    .incident-apps-name {
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: #FFD7D3;
      padding: 5px 8px;
      border-radius: 6px;
      color: #D45446;
      font-size: 12px;
    }
  }
`;

export const AppIncident = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;

  .incident-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    color: ${({ theme }) => theme.brand.primary};

    .incident-status {
      color: #19814e;

      &.major_outage {
        color: #d32f2f;
      }

      &.degraded_performance {
        color: #f5a800;
      }

      &.partial_outage {
        color: #e07000;
      }

      &.maintenance {
        color: #482764;
      }

      &.operational {
        color: #19814e;
      }
    }

    .incident-title {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .incident-collapse-btn {
      border: 1px solid #eaeaea;
      background-color: transparent;
      font-size: 20px;
      cursor: pointer;
      color: ${({ theme }) => theme.brand.primary};
      padding: 0px 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;

      &:hover {
        background-color: #eaeaea;
      }
    }
  }

  .incident-chart {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
    padding: 10px 0px;
    position: relative;
    width: 100%;

    @media (max-width: 1080px) {
      justify-content: flex-start;
    }

    @media (min-width: 1200px) and (max-width: 1300px) {
      justify-content: flex-start;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .incidentitem {
      height: 50px;
      width: 5px;
      background-color: #19814e;
      display: block;
      position: relative;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover,
      &:focus {
        scale: 1.2;
      }

      &.up {
        background-color: #19814e;
      }

      &.down {
        background-color: #d00000;
      }

      &.critical {
        background-color: #d32f2f;
      }

      &.high {
        background-color: #f57c00;
      }

      &.medium {
        background-color: #fbc02d;
      }

      &.low {
        background-color: #7ccbd1;
      }

      &.notice {
        background-color: #607d8b;
      }

      .incidentitem-detail {
        position: fixed;
        bottom: calc(100% + 5px);
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #212121;
        font-size: 12px;
        background-color: #fff;
        padding: 10px 15px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        z-index: 9999;
        font-size: 12px;
        cursor: default;

        &::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          width: 10px;
          height: 10px;
          background-color: #fff;
        }

        svg {
          height: 20px;
          width: 20px;
        }

        h5 {
          font-size: 12px;
        }

        p {
          margin: 0;
          font-size: 10px !important;
        }

        div {
          gap: 5px !important;
        }
      }
    }
  }

  .incident-timings {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    p {
      margin: 0;
      white-space: nowrap;
      font-size: 12px;
    }

    .seperator-horizontal {
      background-color: #eaeaea;
      width: 100%;
      height: 1px;
    }
  }
`;

export const Seperator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #efeeee;
  margin: 20px 0px;
  display: block;
  position: relative;
`;

// viewallservices

export const ViewAllServices = styled.div`
  text-align: center;
  margin-top: 20px;

  button {
    border-radius: 10px;
    padding: 10px 15px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 600;
    font-size: 12px;

    &:hover {
      background-color: #eaeaea;
    }
  }
`;

// dashboard status

export const DashboardStatus = styled.div`
  text-align: center;
  padding: 20px;

  svg {
    height: 50px;
    width: 50px;
  }
`;

// StatusDetail

export const StatusDetail = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  background: #fcf9ff;
  border: 1px solid #482764;
  border-radius: 4px;
  padding: 5px 10px;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    width: 100%;
  }

  svg {
    height: 24px;
    width: 24px;
    flex-shrink: 0;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.brand.headerText};
    font-size: 14px;
    background: ${({ theme }) => theme.brand.headerBackground};
    border: 1px solid ${({ theme }) => theme.brand.headerBackground};
    border-radius: 4px;
    padding: 5px 10px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 5px;

    svg {
      height: 16px;
      width: 16px;
    }
  }
`;

// CategoriesContainer

export const CategoriesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 5px 10px;
  max-width: 750px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
`;

// CategoryItem

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  text-transform: uppercase;
  font-size: 12px;

  svg {
    height: 20px;
    width: 20px;
    flex-shrink: 0;
  }
`;

// ServicesContainer

export const ServicesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
`;

// ServiceItem

export const ServiceItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 8px 12px;

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  svg {
    height: 20px;
    width: 20px;
    flex-shrink: 0;

    &.info-icon {
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
  }
`;

// IncidentTooltipHeader
export const IncidentTooltipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 0px;
  background: #ebecf4;
  color: #212121;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 5px 10px;
  width: 100%;
  margin-top: 5px;

  .tooltip-header-date {
    font-weight: 600;
  }

  .tooltip-header-actions {
    display: flex;
    gap: 5px;
    align-items: center;

    .action-items {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      button {
        border: 1px solid #212121;
        border-radius: 4px;
        background: none;
        cursor: pointer;
        padding: 5px 5px;
        display: flex;
        align-items: center;
        &:hover {
          background: #efeeee;
        }
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        svg {
          height: 10x;
          width: 10x;
          flex-shrink: 0;
        }
      }
    }
  }
`;

// SystemStatusHeader
export const SystemStatusHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @media (max-width: 1080px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

// timezone-disclaimer
export const TimezoneDisclaimer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  background: #ebecf4;
  color: #212121;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 12px;
`;
